import ICalibrationOfficeCommercial = ZoneIQCalibration.ICalibrationOfficeCommercial;
import ICalibrationGeneralImportValidationResult = ZoneIQCalibration.ICalibrationGeneralImportValidationResult;
import { BaseMutableModel } from '../common-models/base-mutable-model.model';

export class CalibrationOfficeCommercialValue extends BaseMutableModel<ICalibrationOfficeCommercial>
    implements ICalibrationOfficeCommercial {
    ZoneCombinationId: number;
    OverlayTypologyId?: number;
    RevisionId: number;

    OfficeMaxStories?: number;
    MaximumResidentialFAR?: any;
    MaximumResidentialFLR?: any;
    MaximumLodgingFAR?: any;
    MaximumLodgingFLR?: any;
    MaximumOfficeFLR?: any;
    MaximumOfficeFAR?: any;
    MaximumCommercialFAR?: any;
    MaximumCommercialFLR?: any;
    OfficeCommercialMaxStories?: number;
    OfficeCommercialMaxPercentArea?: number;
    CommercialEstabMaxArea?: number;
    CommercialFoodMaxSeating?: number;
    DensityNet?: number;
    LodgingDensity?: any;
    UnitAreaMin?: number;
    UnitAreaMax?: any;
    LodgingExchange?: number;
    DensityUL: boolean;
    LodgingDensityUL: boolean;
    IsLodgingExchangeEnabled: boolean;
    RoomAreaMin?: number;
    RoomAreaMax?: any;
    MaximumResidentialPercentArea: number;
    MaximumLodgingPercentArea: number;
    MaximumOfficePercentArea: number;
    MaximumCommercialPercentArea: number;
    MaximumIndustrialPercentArea: number;
    MaximumIndustrialFAR: number;
    MaximumIndustrialFLR: number;
    MaximumCivicPercentArea: number;
    MaximumCivicFAR: number;
    MaximumCivicFLR: number;
    MaximumCivicSupportPercentArea: number;
    MaximumCivicSupportFAR: number;
    MaximumCivicSupportFLR: number;
    MaximumEducationalPercentArea: number;
    MaximumEducationalFAR: number;
    MaximumEducationalFLR: number;

    importValidationResult?: ICalibrationGeneralImportValidationResult;

    settings: any = null;

    constructor(data: ICalibrationOfficeCommercial, fieldSettings?: any) {
        super(data, ['ZoneCombinationId', 'OverlayTypologyId'], fieldSettings);
        if (data) {
            this.importValidationResult = data.importValidationResult;
        }
    }

    static factory(data: ICalibrationOfficeCommercial): CalibrationOfficeCommercialValue {
        return new CalibrationOfficeCommercialValue(data);
    }
}
